// folderSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  folderPath: [], // History of visited folders
  currentFolder: null, // The current folder being viewed
};

const folderSlice = createSlice({
  name: "folder",
  initialState,
  reducers: {
    // Add folder to path (for entering a folder)
    enterFolder: (state, action) => {
      state.folderPath.push(action.payload);
      state.currentFolder = action.payload;
    },
    // Remove the last folder from path (for going back)
    goBack: (state) => {
      state.folderPath.pop();
      state.currentFolder =
        state.folderPath[state.folderPath.length - 1] || null;
    },
    // Reset path (e.g., on a new navigation)
    resetPath: (state) => {
      state.folderPath = [];
      state.currentFolder = null;
    },
  },
});

export const { enterFolder, goBack, resetPath } = folderSlice.actions;
export default folderSlice.reducer;
